var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightbulboutline1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_3365)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.00004 14.2715C6.00004 14.6382 6.30004 14.9382 6.66671 14.9382H9.33337C9.70004 14.9382 10 14.6382 10 14.2715V13.6048H6.00004V14.2715ZM8.00004 1.60483C5.42671 1.60483 3.33337 3.69816 3.33337 6.27149C3.33337 7.85816 4.12671 9.25149 5.33337 10.0982V11.6048C5.33337 11.9715 5.63337 12.2715 6.00004 12.2715H10C10.3667 12.2715 10.6667 11.9715 10.6667 11.6048V10.0982C11.8734 9.25149 12.6667 7.85816 12.6667 6.27149C12.6667 3.69816 10.5734 1.60483 8.00004 1.60483ZM9.33337 9.40483V10.9382H6.66671V9.40483C5.65337 8.69149 4.66671 7.95816 4.66671 6.27149C4.66671 4.43149 6.16004 2.93816 8.00004 2.93816C9.84004 2.93816 11.3334 4.43149 11.3334 6.27149C11.3334 7.93149 10.3267 8.70483 9.33337 9.40483Z",
    fill: "#9C7D16"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_3365"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.271484)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightbulboutline1);
export default __webpack_public_path__ + "static/media/Lightbulb outline1.f1bf8f893754829f382c1dc9bce49f12.svg";
export { ForwardRef as ReactComponent };